export const people = [
  {
    id: "p-1",
    name: "林知夏",
    role: "影视演员",
    initial: "林",
    heat: 88,
    topics: 12,
    desc: "近期因新剧造型与片场路透频上热搜，围绕角色适配度的讨论较多，相关话题尚未获得本人回应。",
    tags: ["影视", "路透"],
  },
  {
    id: "p-2",
    name: "苏念",
    role: "流行歌手",
    initial: "苏",
    heat: 81,
    topics: 9,
    desc: "被卷入品牌解约传闻，工作室称合约正常履行。粉丝后援会呼吁以官方信息为准，勿传播未证实内容。",
    tags: ["明星", "品牌"],
  },
  {
    id: "p-3",
    name: "顾北辰",
    role: "综艺常驻",
    initial: "顾",
    heat: 79,
    topics: 11,
    desc: "所在王牌综艺的录制花絮引发热议，节目组回应录制顺利。网友对其综艺表现评价存在分歧。",
    tags: ["综艺", "传闻"],
  },
  {
    id: "p-4",
    name: "奶芙酱",
    role: "美妆博主",
    initial: "奶",
    heat: 92,
    topics: 15,
    desc: "千万粉丝量级带货主播，近期因直播间商品争议被集中讨论，其团队已开启专属售后通道。",
    tags: ["网红", "带货"],
  },
  {
    id: "p-5",
    name: "祁野",
    role: "电竞主播",
    initial: "祁",
    heat: 74,
    topics: 7,
    desc: "与长期搭档的互动关系变动引发关注，双方发文表示规划不同。后援会已宣布暂停集贤类活动。",
    tags: ["网红", "主播"],
  },
  {
    id: "p-6",
    name: "温言",
    role: "时尚博主",
    initial: "温",
    heat: 66,
    topics: 6,
    desc: "穿搭内容常被用作二次创作素材，近期一组旧活动照被翻出讨论，内容多为公开活动记录。",
    tags: ["网红", "时尚"],
  },
];

export const topics = [
  {
    id: "tp-1",
    title: "年度塌房名场面复盘",
    tag: "专题合集",
    count: 24,
    desc: "把一整年里讨论度最高的争议事件按时间线串起来，从起因、双方回应到后续走向逐条梳理，帮你看懂来龙去脉。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20theatrical%20stage%20with%20warm%20crimson%20curtain%20and%20gold%20spotlight%20beam%20in%20haze%2C%20no%20people%2C%20cinematic%20atmospheric%2C%20editorial%20photography%2C%20deep%20red%20and%20amber%20tones&width=900&height=600&seq=topic-collapse-01&orientation=landscape",
  },
  {
    id: "tp-2",
    title: "顶流恋爱考古手册",
    tag: "话题盘点",
    count: 18,
    desc: "盘点近年来被反复讨论的明星同框、行程重合与互动细节，区分「公开信息」与「网友推测」，理性看待每一条线索。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20romantic%20night%20cityscape%20with%20warm%20bokeh%20lights%20and%20rose%20gold%20glow%2C%20no%20people%2C%20cinematic%20blur%2C%20editorial%20photography%2C%20soft%20amber%20and%20pink%20tones&width=900&height=600&seq=topic-love-02&orientation=landscape",
  },
  {
    id: "tp-3",
    title: "网红带货翻车观察",
    tag: "行业观察",
    count: 21,
    desc: "汇总直播间商品争议的常见类型与处理方式，从售后响应、品牌核实到平台规则，教你遇到问题时如何理性维权。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20livestream%20ring%20light%20setup%20with%20warm%20amber%20glow%20and%20blurred%20packaging%20boxes%2C%20no%20people%2C%20cinematic%20bokeh%2C%20editorial%20product%20photography%2C%20warm%20gold%20tones&width=900&height=600&seq=topic-livestream-03&orientation=landscape",
  },
];